import React, {
	Component
} from 'react';
import {
	setTokenData,
	reactLoader,
	setUserData,
	parseJwt,
	message
} from '../helpers/Common';
import {
	domainUrl,
	sessExpire
} from '../config/Config';
import * as Common from '../helpers/Common';

export default class CorporateLogin extends Component {
	componentDidMount() {
		reactLoader("show", "Please wait...");
		fetch(domainUrl + "user/login", {
			method: "POST",
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json'
			},
			body: JSON.stringify({
				authuser: this.props.params.accessCode,
				type: 'corporate'
			})
		}).then((response) => response.json()).then((responseJson) => {
			reactLoader("hide");
			if (responseJson.status === 0) {
				message(responseJson.message, responseJson.errors, "error");
			} else {
				setTokenData("token", responseJson.token);
				setUserData("isLoggedIn", true);

				Common.message("Test","Welcome",'');
				let date = new Date();
				date.setSeconds(date.getSeconds() + sessExpire);
				setUserData("sessMax", date.getTime());
				setTimeout(() => {
					let decodeJson = parseJwt(responseJson.token);
					if (decodeJson.beforeRoutes.length > 0) {
						this.props.router.push(decodeJson.beforeRoutes[0].url);
					} else if (decodeJson.afterRoutes.length > 0) {
						this.props.router.push(decodeJson.afterRoutes[0].url);
					} else {
						this.props.router.push(decodeJson.routePath);
					}
				}, 500);
			}
		});
	}
  render() {
    return (
      <div></div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/auth/CorporateLogin.js